module.exports = __webpack_public_path__ + "img/none.583944c6.png";